
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utiles/[slug]",
      function () {
        return require("private-next-pages/utiles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utiles/[slug]"])
      });
    }
  